import { FontWeights, IProcessedStyleSet, mergeStyleSets } from 'office-ui-fabric-react';
import { AppVoiceRecorderStyles } from './AppVoiceRecorder.props';
import { AppLayoutSettings } from '../../common/styles/common.styles';

export const getAppVoiceRecorderStyles = (
  customStyles?: Partial<AppVoiceRecorderStyles>
): IProcessedStyleSet<AppVoiceRecorderStyles> => {
  const styles: AppVoiceRecorderStyles = {
    root: {
      flexDirection: 'column',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    timer: {
      fontSize: AppLayoutSettings.AppFontSize.extraLargeFontSizePx,
      fontWeight: FontWeights.regular,
      fontFamily: 'Bahnschrift, "Bahnschrift Web", "Segoe UI", "Helvetica Neue"',
      color: AppLayoutSettings.getAppColorContainer().darkLabelColor.value
    },
    micWidgetContainer: {
      marginTop: '3px',
      position: 'relative'
    },
    statusLabelContainer: {
      marginTop: '40px',
    },
    statusLabel: {
      color: AppLayoutSettings.getAppColorContainer().darkLabelColor.value
    },
    buttonContainer: {
      marginTop: '36px'
    },
    cancelButtonContainer: {
    }
  };

  return mergeStyleSets(styles, customStyles);
};